"use client";

import { useState } from "react";
import { I } from "@/components/kamibot-v2/discord";
import { Container } from "@/components/kamibot-v2/common";

const tiers = [
  { kr: "₩3,000", note: "라면 한 그릇" },
  { kr: "₩7,000", note: "야식값" },
  { kr: "₩15,000", note: "한 달 서버비" },
  { kr: "직접 입력", note: "마음 가는 만큼" },
];

// 결제 연동/후원 페이지 정비가 끝나기 전까지 후원 카드를 잠시 숨겨둠.
// (대략 1주일 뒤 다시 켜기 — 결제 연동이 완료되면 true 로 바꾸면 끝.)
const SHOW_DONATE_CARD = false;

export function Support() {
  const [amt, setAmt] = useState(1);
  // 후원 카드를 숨길 때도 hooks 순서가 흔들리지 않도록 useState 는 항상 호출.
  void amt;

  return (
    <section id="support">
      <Container>
        <div className={`support ${SHOW_DONATE_CARD ? "" : "support-solo"}`}>
          {SHOW_DONATE_CARD && (
            <div className="support-card support-donate">
              <span className="eyebrow">SUPPORT · 지금</span>
              <h3>마음에 드시면, 라면 한 그릇 정도 응원해주세요.</h3>
              <p>
                카미봇의 핵심 기능은 무료예요. 서포터 멤버십은 마음이 가실 때만. 받은 응원은 서버 비용과 새 기능 개발에 그대로 써요.
              </p>
              <div className="donate-row">
                {tiers.map((t, i) => (
                  <button
                    key={i}
                    type="button"
                    className={`donate-chip ${i === amt ? "active" : ""}`}
                    onClick={() => setAmt(i)}
                  >
                    {t.kr}
                    <small>{t.note}</small>
                  </button>
                ))}
              </div>
              <div className="donate-action">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    // TODO: 결제 연동
                  }}
                >
                  <I.heart /> 멤버십 가입하기 <I.arrow />
                </button>
              </div>
            </div>
          )}
          <div className="support-card support-soon">
            <span className="soon-badge">
              <I.lock /> SOON · 준비 중
            </span>
            <h3>조금 더 든든한 카미봇이 곧 와요.</h3>
            <p>
              몇 달 안에 프리미엄 플랜을 준비하고 있어요. 더 긴 TTS, 더 많은 AI 토큰, 우선 지원 같은 것들이요. 지금 가격을 정해두진 않았어요.
            </p>
            <div className="soon-fields">
              <div className="soon-field">
                <span className="check" />
                <span className="label">긴 TTS · 고급 음성 모델</span>
                <I.lock className="lock" />
              </div>
              <div className="soon-field">
                <span className="check" />
                <span className="label">AI 어시스턴트 무제한 토큰</span>
                <I.lock className="lock" />
              </div>
              <div className="soon-field">
                <span className="check" />
                <span className="label">서버 분석 · 우선 지원</span>
                <I.lock className="lock" />
              </div>
            </div>
            <div className="soon-input">
              <input placeholder="이메일 — 준비되면 알려드릴게요" />
              <button
                type="button"
                onClick={() => {
                  // TODO: 메일링 리스트 백엔드
                }}
              >
                알림 받기
              </button>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
